import { Hoja } from "../models/Hoja";
import { Llamada } from "../models/Llamada";
import { Vehiculo } from "../models/Vehiculo";
import { Asegurado } from "../models/Asegurado";
import { Cliente } from "../models/Cliente";
import { ArticuloContact } from "../models/ArticuloContact";
import { HojasCallCenterComponent } from "../hojas-call-center.component";
export class GestionHoja
{
  //rellena los datos diversos para la hoja a partir de lo que se ha ido rellenando hasta ahora
  /*public static rellenarDatos(llamada:Llamada, taller:number,vehiculo:Vehiculo,cia:Cliente,asegurado:Asegurado,articulosSeleccionados:ArticuloContact[],usuario:string):Hoja
  {
    let hojaRellenada : Hoja = Hoja.hojaVacia();
    hojaRellenada = GestionHoja.rellenarDeLlamada(hojaRellenada,llamada);
    hojaRellenada = GestionHoja.rellenarDeVehiculo(hojaRellenada,vehiculo,articulosSeleccionados);
    hojaRellenada = GestionHoja.rellenarDeAsegurado(hojaRellenada,asegurado);
    hojaRellenada.articulos = articulosSeleccionados;


    hojaRellenada.usuario = usuario.trim();
    hojaRellenada.taller = taller;
    hojaRellenada.numcli = cia.cliente.trim();
    if (cia.cliente.trim() == "140334"){
      hojaRellenada.estadoPresupuesto = "P";
    }else{
      hojaRellenada.estadoPresupuesto = "";
    }
    hojaRellenada.entidad = 0;
    return hojaRellenada;
  }*/

  public static rellenarDatosNew(formularioHojas: HojasCallCenterComponent):Hoja
  {
    let hojaRellenada : Hoja = Hoja.hojaVacia();
    hojaRellenada = GestionHoja.rellenarDeLlamada(hojaRellenada,formularioHojas.llamada);
    hojaRellenada = GestionHoja.rellenarDeVehiculo(hojaRellenada,formularioHojas.vehiculo,formularioHojas.artsSeleccionados,formularioHojas.extranjera);
    hojaRellenada = GestionHoja.rellenarDeAsegurado(hojaRellenada,formularioHojas.asegurado);
    hojaRellenada.articulos = formularioHojas.artsSeleccionados;


    hojaRellenada.usuario = formularioHojas.usuario.trim();
    hojaRellenada.taller = formularioHojas.tallerSeleccionado!.delegacion;
    hojaRellenada.numcli = formularioHojas.ciaSeleccionada!.cliente.trim();
    if (formularioHojas.ciaSeleccionada!.cliente.trim() == "140334"){
      hojaRellenada.estadoPresupuesto = "P";
    }else{
      hojaRellenada.estadoPresupuesto = "";
    }
    hojaRellenada.entidad = 0;

    hojaRellenada.entidad = isNaN(Number.parseInt(formularioHojas.entidadSeleccionada)) ? 0 : Number.parseInt(formularioHojas.entidadSeleccionada);
    hojaRellenada.articulos = formularioHojas.artsSeleccionados;
    hojaRellenada.obser = formularioHojas.mensajeObser;
    hojaRellenada.umCalibra = formularioHojas.selectAdas;
    hojaRellenada.campa = formularioHojas.campaContactRls;
    hojaRellenada.idlinea = isNaN(Number.parseInt(formularioHojas.idlinea)) ? 0 : Number.parseInt(formularioHojas.idlinea);
    hojaRellenada.idcorredor =  isNaN(Number.parseInt(formularioHojas.idcorredor)) ? 0 : Number.parseInt(formularioHojas.idcorredor);
    hojaRellenada.idservicios =  isNaN(Number.parseInt(formularioHojas.idservicios)) ? 0 : Number.parseInt(formularioHojas.idservicios);
    hojaRellenada.idgestionweb =  isNaN(Number.parseInt(formularioHojas.idgestionweb)) ? 0 : Number.parseInt(formularioHojas.idgestionweb);
    hojaRellenada.idAlphabet =  isNaN(Number.parseInt(formularioHojas.idAlphabet)) ? 0 : Number.parseInt(formularioHojas.idAlphabet);
    hojaRellenada.caseId = formularioHojas.caseID.toString().trim();

    if(hojaRellenada.suslloc == "" && formularioHojas.auxSusLloc != "" && !formularioHojas.tallerBooking){
      hojaRellenada.suslloc = formularioHojas.auxSusLloc;
    }else if(formularioHojas.tallerBooking){
      hojaRellenada.suslloc = formularioHojas.trabajoSeleccionado;
    }

    if (formularioHojas.fechaCitaBooking != "" )
    {
        hojaRellenada.fec_cita = formularioHojas.fechaCitaBooking;
    }    
    
    hojaRellenada.hora_cita = formularioHojas.horaCitaBooking;
    hojaRellenada.pickup = formularioHojas.pickupDateBooking;

    const infoExtra = formularioHojas.getInfoSiniestroFormateada();

    const clienteActual = (formularioHojas.ciaSeleccionada?.cliente || '').toString().trim();
    const esMutua = formularioHojas.clientesMutua.includes(clienteActual);

    if (esMutua && infoExtra) {
      hojaRellenada.suc_detalle = infoExtra;
    }

    return hojaRellenada;
  }

  //se encarga de rellenar los apartados del vehculo
  //se encarga de rellenar los apartados del vehculo
  private static rellenarDeVehiculo(hoja:Hoja,vehiculo:Vehiculo,articulo: ArticuloContact[],extranjera: boolean):Hoja
  {
    hoja.extranjera = extranjera;
    hoja.$matricula = vehiculo.matricula;
    hoja.marca=vehiculo.marca;
    hoja.modelo=vehiculo.modelo;
    hoja.color=vehiculo.color;
    hoja.bastidor=vehiculo.bastidor;
    hoja.km = isNaN(Number.parseInt(vehiculo.km)) ? 0 : Number.parseInt(vehiculo.km);
    hoja.sucdesc = vehiculo.descSiniestro.toString().trim();//EJ: granizo, estacionado, vandalismo..
    if(vehiculo.trabajos == ""){
      switch (articulo.length){
        case 0:
          hoja.suslloc = "";
          break;
        case 1:
          if (articulo[0].articulo === "99000001" || articulo[0].articulo.substring(0, 3) === "700") {
            hoja.suslloc = articulo[0].desc;
          } else {
            hoja.suslloc = "";
          }
          break;
        default:
          if (articulo[0].articulo === "99000001"|| articulo[0].articulo === "99000002" || articulo[0].articulo.substring(0, 3) === "700") {
            hoja.suslloc = articulo[0].desc;
          } else {
            hoja.suslloc = "";
          }
          break;
      }
    }else{
      hoja.suslloc = vehiculo.trabajos;//SERVICIO/trabajo a realizar
    }

    return hoja;
  }
  //rellena datos disponibles en Asegurado
  private static rellenarDeAsegurado(hoja:Hoja,asegurado:Asegurado):Hoja
  {
    hoja.agente = asegurado.agente.toString().trim();
    hoja.dni = asegurado.dni.toString().trim();
    hoja.emailCli = asegurado.email.toString().trim();
    hoja.nombreCli = asegurado.nombre.toString().trim();
    hoja.siniestro = asegurado.siniestro.trim();
    hoja.telfCli = asegurado.tel1.toString().trim();
    hoja.telfCli2 = asegurado.tel2.toString().trim();
    hoja.poliza = asegurado.poliza.toUpperCase();
    if (asegurado.fecSin && asegurado.fecSin != ""){
      hoja.fecsin = asegurado.fecSin;
    }
    if(asegurado.servicio == "taller"){
      hoja.servicio = "NO";
    }else{
      hoja.servicio = "SI";
    }
    hoja.desservicio = asegurado.servicio.toString().toUpperCase();
    //let agente = Number.parseInt(asegurado.agente.trim());
    //hoja.idcorredor = !isNaN(agente) ? agente : 0;
    hoja.dirCli = asegurado.dirCliente.toString().trim().substring(0,40);
    return hoja;
  }

  private static rellenarDeLlamada(hoja:Hoja,llamada:Llamada):Hoja
  {
    hoja.piloto = llamada.entrada.trim();
    hoja.origen = llamada.origen.trim();
    hoja.tipocall = llamada.tipo.trim();
    hoja.quien = llamada.recomendado.trim();
    if(llamada.entrada.trim() == "100000026"){
      hoja.par11 = "S";
    }
    return hoja;
  }

  //pattern="^(?=.{1,100}$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
  //verifica si los parametros son validos
  public static datosValidos(hoja:Hoja):boolean
  {
    // Define un array con las expresiones regulares a validar
    //const patronesValidacion :PatronValidacion[] =
    const patronesValidacion  =
    {
      //new PatronValidacion("emailCli",/^(?=.{1,100}$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),// Para validar correo,
      emailCli:/^(?=.{1,100}$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    }

    patronesValidacion.emailCli.test(hoja.emailCli);

  // Si todas las validaciones son exitosas, retorna true
    return true;
  }

}

export class PatronValidacion
{
  public propiedad:string = "";
  public patron:RegExp | undefined;

  constructor(nombrePropiedad:string, patron:RegExp)
  {
    this.propiedad = nombrePropiedad;
    this.patron = patron;
  }
}
